export type UserWithPlan = {
  plan?: string;
  role?: string;
  ugcLibraryAddon?: boolean;
  preferences?: {
    collectionUserCanAccess?: string[];
  };
};

export function isFullLibrary(user?: UserWithPlan) {
  if (!user || !user.plan) {
    return false;
  }

  if (user.ugcLibraryAddon) {
    return true;
  }

  return [
    "essentials",
    "marketer",
    "professional",
    "agency",
    "enterprise",
    "custom",
  ].some((plan) => user.plan?.includes(plan));
}

export function isLibraryRestricted(user: UserWithPlan) {
  return !isFullLibrary(user);
}

export function isCollaboratorLibraryRestricted(user: UserWithPlan) {
  const role = user.role;
  const collectionUserCanAccess =
    user?.preferences?.collectionUserCanAccess || [];

  return role === "collaborator" && collectionUserCanAccess.length > 0;
}
